import { core } from "@tauri-apps/api";

export const deleteRoadmapItem = async (id: string) => {
  // Rückgabewert ist nur void; wir werfen Fehler weiter,
  // damit React-Query sie fangen kann.
  await core.invoke("delete_roadmap_item", { id });
};
